import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Spinner } from "../utils";
import { ITermOverview } from "./TermOverview";
import { ISearchParamsAware, IPaginationAware } from "./ISearchParams";

import "bootstrap/dist/css/bootstrap.css";

interface ITermsTable extends ISearchParamsAware, IPaginationAware {
  rowsProvider: any;
}

const TermsTable: React.FC<ITermsTable> = props => {
  const { rowsProvider, searchParams, setCurrentPage, setTotalPages } = props;

  const { i18n } = useTranslation();
  const [isSearching, setIsSearching] = useState(false);
  const [results, setResults] = useState<ITermOverview[]>([]);

  const fetchTerms = async (url: string) => {
    setIsSearching(true);

    const response = await fetch(url);
    const data = await response.json();
    const pagesCount = Math.ceil(data.total_results / searchParams.limit);
    const currentPage =
      Math.floor(searchParams.offset / searchParams.limit) + 1;

    setResults(data.terms);
    setCurrentPage(currentPage);
    setTotalPages(pagesCount);
    setIsSearching(false);
  };

  useEffect(() => {
    const { query, limit, offset } = searchParams;
    const url = `_query?query=${query}&limit=${limit}&offset=${offset}`;
    fetchTerms(url);
  }, [searchParams, i18n.language]);

  return (
    <table className="table table-condensed" data-cy="table-terms">
      {isSearching ? (
        <Spinner />
      ) : (
        <tbody>{results.map(result => rowsProvider(result))}</tbody>
      )}
    </table>
  );
};

export default TermsTable;
